import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CssBaseline,  ThemeProvider } from "@mui/material";
import keycloak from "./Keycloak";
import { theme } from "./styles/theme";
import ErrorBoundary from "./ErrorBoundary";
const container = document.getElementById('root')!;
const root = createRoot(container);

Object.defineProperty(window, 'reduxStore', {
    get() {
        return store.getState();
    },
});
keycloak.init({ onLoad: 'check-sso' }).then(() => {
})//Root rendering is chained after keycloak init to ensure that keycloak inits first before the app starts.
    .then(() => root.render(
        <React.StrictMode>
            <ErrorBoundary>
                <Provider store={store}>
                    <ThemeProvider theme={theme}>
                        <CssBaseline />
                        <BrowserRouter>
                            <Routes>
                                <Route path="/*" element={<App />} />
                            </Routes>
                        </BrowserRouter>
                    </ThemeProvider>
                </Provider>
            </ErrorBoundary>
        </React.StrictMode>
    ));


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
